/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "user-management",
	data() {
		return {
			users: [],
			userHeadings: [
				{
					text: "First Name",
					field: "firstName"
				},
				{
					text: "Last Name",
					field: "lastName"
				},
				{
					text: "Email Address",
					field: "email"
				},
				{
					text: "Role",
					field: "role"
				},
				{
					text: "Is Active",
					field: "isActive"
				},
				{
					text: "Date Created",
					field: "insertedOnString"
				}
			],
			actions: [],
			actionKeys:{
				edit: "edit",
				markAsActiveInactive: "markAsActiveInactive",
				resetPassword: "resetPassword",
				viewCustomers: "viewCustomers"
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filterStateChanged: false,
			roles: [],
			rolesFilter: [],
			userAddEditFormModal:{
				showModal: false,
				isSaving: false,
				modalId: "addOrEditUserModal",
				heading: "Add User"
			},
			user:{
				userId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			markAsActiveOrInactive:{
				heading: "Mark User As Active/Inactive",
				modalId: "markAsActiveOrInactiveUserModal",
				isSaving: false,
				showModal: false,
				isUserMarkedAsActiveKey: 1,
				isActive: true,
				userId: null
			},
			userPasswordReset:{
				showModal: false,
				modalId: "userPasswordResetModal",
				userId: null,
				name: null
			},
			salesRepCustomers:{
				heading: "Sales Rep Customers",
				modalId: "salesRepCustomersModal",
				showModal: false,
				userId: null
			},
			filter:{
				roleId: null,
				selectedRole: 0,
				searchQuery: null,
				activeOrInactiveItems: 1,
			},
			activeIsActiveKey:{
				active: 1,
				inactive: 0
			},
			role:{
				admin: 1,
				salesRep: 2,
				depotSupervisor: 3
			},
			isUpdate: false,
			resetPassword: false,
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getUsers(){
			this.loading = true;
			console.log("filter.activeOrInactiveItems", this.filter.activeOrInactiveItems);
			let request = {
				roleId: this.filter.roleId,
				isActive: castingUtility.toBoolean(this.filter.activeOrInactiveItems),
				searchText: this.filter.searchQuery
			};
			securityService.getAllInternalUsers(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.users = successResponse.data.result;
						for(let i = 0; i < this.users.length; i++){
							console.log("isActive", this.users[i].isActive);
							this.users[i].actions = [
								{
									name: "Edit",
									key: this.actionKeys.edit,
									elementId: "btnUserManagementEditAction"
								},
								{
									name: this.users[i].isActive ? "Mark As Inactive" : "Mark As Active",
									key: this.actionKeys.markAsActiveInactive,
									elementId: "btnUserManagementMarkAsActiveInactiveAction"
								},
								{
									name: "Reset Password",
									key: this.actionKeys.resetPassword,
									elementId: "btnUserManagementResetPasswordAction"
								}
							];
							if(roleHelper.role.userType1 === this.users[i].roleId){
								this.users[i].role = "User Type 1";
							}
							else if(roleHelper.role.userType2 === this.users[i].roleId){
								this.users[i].role = "User Type 2";
							}
							else if(roleHelper.role.specialUser === this.users[i].roleId){
								this.users[i].role = "Special User";
							}
							else if(roleHelper.role.admin === this.users[i].roleId){
								this.users[i].role = "Admin";
							}
						}
						this.users = dataTableHelper.castFieldValues(this.users);
						this.filterStateChanged = false;
						//this.filter.selectedRole = 0;
						console.log("users", this.users);
					}
					this.loading = false;
					console.log("loading", this.loading);
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
			
		},
		getRoles(){
			// TODO: get from api
			var rolesForUsers = securityService.getRoles();
			this.roles = rolesForUsers;
			this.rolesFilter = rolesForUsers;
			this.roles = $.map(this.roles,
				function (obj) {
					obj.id = obj.id || obj.roleId;
					obj.text = obj.text || obj.role;
					return obj;
				});
			
			this.rolesFilter.unshift(
				{
					roleId: 0,
					role: "All"
				});
			this.rolesFilter = $.map(this.rolesFilter,
				function (obj) {
					obj.id = obj.id || obj.roleId;
					obj.text = obj.text || obj.role;
					return obj;
				});
			console.log("roles", this.roles);
		},
		setUserManagementActions(){
			this.actions = [
				{
					name: "Edit",
					key: this.actionKeys.edit
				},
				{
					name: "Mark As Active Or Inactive",
					key: this.actionKeys.markAsActiveInactive
				},
				{
					name: "Reset Password",
					key: this.actionKeys.resetPassword
				}
			];
		},
		onFilterSearchClicked(){
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getUsers();
		},
		onRoleFilterSelect(role){
			console.log("role", role);
			if(this.filter.selectedRole !== role.id) {
				this.filterStateChanged = true;
			}
			this.filter.selectedRole = role.id;
			if(role.id === 0){
				this.filter.roleId = null;
			}
			else{
				this.filter.roleId = role.id;
			}
			
			console.log("filter", this.filter);
		},
		onActiveInactiveFilterSelected(activeOrInactiveKey){
			this.filter.activeOrInactiveItems = activeOrInactiveKey;
			this.filterStateChanged = true;
			console.log("filter", this.filter);
		},
		onPagingUpdate(paging) {
			console.log("paging", paging);
			this.pagingDetails = paging;
		},
		onAddUserClick(){
			this.isUpdate = false;
			this.userAddEditFormModal.showModal = true;
			this.userAddEditFormModal.heading = "Add User";
		},
		onUserManagementActionClicked(actionAndData){
			console.log("actionAndData", actionAndData);
			switch(actionAndData.action){
				case this.actionKeys.edit:
					this.isUpdate = true;
					this.userAddEditFormModal.showModal = true;
					this.userAddEditFormModal.heading = "Edit User";
					this.user.userId = actionAndData.data.userId;
					this.user.firstName.value = actionAndData.data.firstName;
					this.user.lastName.value = actionAndData.data.lastName;
					this.user.emailAddress.value = actionAndData.data.email;
					this.user.roleId.value = actionAndData.data.roleId;
					break;
				case this.actionKeys.resetPassword:
					this.userPasswordReset.showModal = true;
					this.userPasswordReset.userId = actionAndData.data.userId;
					this.userPasswordReset.name = actionAndData.data.firstName + " " + actionAndData.data.lastName;
					break;
				case this.actionKeys.markAsActiveInactive:
					this.markAsActiveOrInactive.showModal = true;
					this.markAsActiveOrInactive.userId = actionAndData.data.userId;
					//this.markAsActiveOrInactive.heading = this.markAsActiveOrInactive.heading + " - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.markAsActiveOrInactive.isActive = castingUtility.toBoolean(actionAndData.data.isActive);
					this.markAsActiveOrInactive.heading = this.markAsActiveOrInactive.isActive ? "Mark As Inactive - " + actionAndData.data.firstName + " " + actionAndData.data.lastName : "Mark As Active - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.markAsActiveOrInactive.isUserMarkedAsActiveKey = castingUtility.booleanToNumber(actionAndData.data.isActive);
					break;
				case this.actionKeys.viewCustomers:
					this.salesRepCustomers.userId = actionAndData.data.userId;
					this.salesRepCustomers.heading = this.salesRepCustomers.heading + " - " + actionAndData.data.firstName + " " + actionAndData.data.lastName;
					this.salesRepCustomers.showModal = true;
					break;
			}
		},
		onPasswordGenerated(password){
			this.user.password.value = password;
		},
		onMarkAsActiveOrInactiveModalCloseClick(){
			this.markAsActiveOrInactive.showModal = false;
			this.clearMarkAsActiveOrInactiveModel();
		},
		onMarkAsActiveOrInactiveModalSaveButtonClicked(isMarkedAsActive){
			// save mark as active/inactive
			this.markAsActiveOrInactive.isSaving = true;
			let request = {
				userId: this.markAsActiveOrInactive.userId,
				isActive: isMarkedAsActive
			};
			securityService.markUserAsActiveOrInactive(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						this.getUsers();
						this.clearMarkAsActiveOrInactiveModel();
					}
					this.markAsActiveOrInactive.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					this.markAsActiveOrInactive.isSaving = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onMarkUserActiveInactiveSelected(activeOrInactiveKey){
			this.markAsActiveOrInactive.isUserMarkedAsActiveKey = activeOrInactiveKey;
			//TODO: save active/inactive
		},
		onRoleSelect(role){
			this.user.roleId.value = role.id;
		},
		onAddOrEditModalCloseClick(){
			this.userAddEditFormModal.showModal = false;
			this.clearUserModel();
		},
		onAddOrEditUserFormModalSaveButtonClicked(){
			this.userAddEditFormModal.isSaving = true;
			let savePassword = true;
			if(this.isUpdate && !this.resetPassword){
				savePassword = false;
			}
			let request= {
				userId: this.user.userId,
				firstName: this.user.firstName.value,
				lastName: this.user.lastName.value,
				email: this.user.emailAddress.value,
				password: this.user.password.value,
				roleId: this.user.roleId.value === null ? 0 : this.user.roleId.value,
				savePassword: savePassword
			};
			console.log("request", request);
			securityService.addOrUpdateUser(request).then(
				successResponse => {
					var isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						//success
						console.log("success", successResponse);
						if(successResponse.data.userValidationResponse.valuesAreValid) {
							this.clearUserModel();
							this.getUsers();
							this.userAddEditFormModal.showModal = false;
						}
						else{
							this.user.firstName.hasError = successResponse.data.userValidationResponse.firstNameValidationResponse.hasError;
							this.user.firstName.errorMessage = successResponse.data.userValidationResponse.firstNameValidationResponse.message;

							this.user.lastName.hasError = successResponse.data.userValidationResponse.lastNameValidationResponse.hasError;
							this.user.lastName.errorMessage = successResponse.data.userValidationResponse.lastNameValidationResponse.message;

							this.user.emailAddress.hasError = successResponse.data.userValidationResponse.emailValidationResponse.hasError;
							this.user.emailAddress.errorMessage = successResponse.data.userValidationResponse.emailValidationResponse.message;
							
							this.user.roleId.hasError = successResponse.data.userValidationResponse.roleValidationResponse.hasError;
							this.user.roleId.errorMessage = successResponse.data.userValidationResponse.roleValidationResponse.message;
							
							this.user.password.hasError = successResponse.data.userValidationResponse.passwordValidationResponse.hasError;
							this.user.password.errorMessage = successResponse.data.userValidationResponse.passwordValidationResponse.message;
						}
					}
					this.userAddEditFormModal.isSaving = false;
				},
				errorResponse => {
					//error
					console.log("error", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.userAddEditFormModal.isSaving = false;
				}
			);
		},
		onPasswordGeneratorOkClicked(){
			this.userPasswordReset.showModal = false;
			console.log("showModal", this.userPasswordReset.showModal);
			
		},
		onSaleRepCustomerManagementModalOkClicked(){
			this.salesRepCustomers.showModal = false;
			this.clearSaleRepCustomersModel();
		},
		clearUserModel(){
			this.user = {
				userId: null,
				firstName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				lastName: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				emailAddress: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				roleId: {
					value: null,
					hasError: false,
					errorMessage: null
				},
				password: {
					value: null,
					hasError: false,
					errorMessage: null
				}
			};
		},
		clearMarkAsActiveOrInactiveModel(){
			this.markAsActiveOrInactive = {
				heading: "Mark User As Active/Inactive",
				modalId: "markAsActiveOrInactiveUserModal",
				isSaving: false,
				showModal: false,
				isUserMarkedAsActiveKey: 1,
				userId: null
			};
		},
		clearSaleRepCustomersModel(){
			this.salesRepCustomers = {
				heading: "Sales Rep Customers",
				modalId: "salesRepCustomersModal",
				showModal: false,
				userId: null
			};
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("User Management");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "User Management");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getRoles();
		//this.setUserManagementActions();
		this.getUsers();
	}
};